import L from 'leaflet';

const tiles =
  'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}{r}.png';
const attribution =
  '&copy; <a href="https://osm.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors';

const initializeMap = (id, settings = {}) => {
  const { center = [0, 0], zoom = 1, ...rest } = settings;
  const map = L.map(id, rest).setView(center, zoom);

  L.tileLayer(tiles, { attribution }).addTo(map);

  return map;
};

export { L, initializeMap };
